import styled from "@emotion/styled"
import Button from "@mui/material/Button"
import { colors } from "../../theme/colors"

export const ContentContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  rowGap: "8px",
}

export const WhiteContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "480px",
  boxSizing: "border-box",
}

export const TitleContainer = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px",
}

export const TextButton = {
  display: "contents",
}

export const Title = {
  marginBottom: "4px",
}

export const Subtitle = {
  marginBottom: "10px",
}

export const BankButtons = {
  height: 64,
  display: "flex",
  alignItems: "center",
  gap: "10px",
  overflow: "auto",
}

export const SetButton = styled(Button)({
  width: "100%",
  fontWeight: 500,
  marginTop: 10,
  minHeight: 54,
  "&.Mui-disabled": {
    backgroundColor: colors.lightGrey,
    opacity: "40%"
  },
})

export const UnSetButton = styled(Button)({
  background: "#FF000015",
  width: "100%",
  fontWeight: 500,
  marginTop: 10,
  minHeight: 54,
  "&.Mui-disabled": {
    backgroundColor: "rgba(255, 0, 0, 0.1)",
    opacity: "40%"
  },
})

export const BankButton = ({ active }: { active?: boolean }) => ({
  display: "flex",
  width: "fit-content",
  height: "fit-content",
  borderRadius: "40%",
  boxSizing: "border-box",
  border: "1px solid",
  borderColor: active ? colors.yellow : "transparent",
  padding: "3px",
})
